import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ONBOARDING_STEP_EVENT } from '../../../constants/analyticEvents';
import { pushEvent } from '../../../utilities/analytics';
import { setCurrentStep, setDataV2 } from '../onboardingSlice';
import { selectFilterData } from '../../../features/mainFilter/selectors';
import WizardXpButton from '../components/WizardXpButton';
import { getWizardV2State } from '../wizardService';
import { getParamFromUrl } from '../../../utilities/urlResolver';
import { isMobile } from '../../../utilities/helpers';
import SimilarDestinationsDesktop from '../../wizardDesktop/steps/SimilarDestinationsDesktop';

const SimilarDestinationsStep = () => {
  const stepConfig = getWizardV2State().similarDestinationsStep;
  const dispatch = useDispatch();
  const { searchEngine } = useSelector(selectFilterData);

  let destinationId = getParamFromUrl('destinations') || getParamFromUrl('pr_destinations');
  let groupId = getParamFromUrl('destinationsGroups') || getParamFromUrl('pr_destinationsGroups');
  if (destinationId && destinationId.length > 0) {
    destinationId = destinationId[0];
  }
  if (groupId && groupId.length > 0) {
    groupId = groupId[0];
  }
  let destinationName = '';
  if (
    (destinationId || groupId) &&
    searchEngine &&
    searchEngine.where &&
    searchEngine.where.destinations &&
    searchEngine.where.destinations.length > 0
  ) {
    const destinations = searchEngine.where.destinations.filter((destination) => destination.id === destinationId);
    const destGroups = searchEngine.where.destinationsGroups.filter((group) => group.id === groupId);

    if (destGroups.length) {
      destinationName = destGroups[0].name;
    } else if (destinations.length > 0) {
      destinationName = destinations[0].name;
    }
  }

  const { formV2: form, step } = useSelector(state => state.onboarding);

  const handleClick = (item) => {
    dispatch(setDataV2({ similarDestinations: item }));
  };

  const isActive = (item) => {
    const sdDefaultOpt = window.holidayFinder?.similarDestinationsDefaultOpt || +localStorage.getItem('similarDestinationsDefaultOpt') || 2;
    return (
      (form.similarDestinations && form.similarDestinations === item) ||
      (!form.similarDestinations && sdDefaultOpt && stepConfig.items[sdDefaultOpt - 1].value === item)
    );
  };

  const handleContinueClick = () => {
    dispatch(setCurrentStep(1));
    pushEvent(ONBOARDING_STEP_EVENT, {
      step,
      stepName: 'similarDestinations',
      question: stepConfig.title,
      selection: form.similarDestinations,
      skipAvailable: !!(localStorage.getItem('onboardingCompleted')),
    });
  };

  if (!isMobile()) {
    return (
      <SimilarDestinationsDesktop
        stepConfig={stepConfig}
        destinationName={destinationName}
        handleClick={handleClick}
        isActive={isActive}
        onContinueClick={handleContinueClick}
      />
    )
  }

  return (
    <div>
      <div className="wizard-step wizard-similardest-step">
        <div className="wizard-step__title">{stepConfig.title}</div>
        <div className="wizard-step__options">
          {
            stepConfig.items.map((item, i) => (
              <WizardXpButton
                key={i}
                label={item.text.replace('%destination%', destinationName)}
                onClick={() => handleClick(item.value)}
                active={isActive(item.value)}
                className={`slide-in-bottom animation-delay-${i * 50}`}
              />
            ))
          }
        </div>
      </div>

      <div className="wizard-footer">
        <button className="wizard-control-button" onClick={handleContinueClick}>{stepConfig.buttonText}</button>
      </div>
    </div>
  );
}

export default SimilarDestinationsStep;
